<mat-dialog-content> {{message}} </mat-dialog-content> 

<br/> <br/>

<div style = "text-align: center">
    
    <button (click) = "onConfirmClick()" mat-raised-button [ngClass] = "clase" tabindex = "-1">
                
        {{cancelButtonText}}
    
    </button>

</div>